import { Box, Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export const Actions = ({ trainingId }: { trainingId: number }) => {
  const { navigation } = useNavigation()
  return (
    <Box flexDirection="row" gap="s8">
      <Button.Router
        to={navigation.trainings.list.details_revamp.view.surveys.newSurvey.fullPath({
          id: trainingId,
        })}
        iconName="add"
      >
        {i18n.t('trainings.surveys.all_forms_datatable.new_survey_button')}
      </Button.Router>
    </Box>
  )
}
